// Autogenerated by `pnpm version-file`. DO NOT EDIT
export var VERSION = '1.44.0';
//# sourceMappingURL=version.js.map